import * as React from 'react';

import GamerTag from './GamerTag.jsx';

import { useUserdata } from '../AppContext';

const PlayerTag = (props) => {
	const userdata = useUserdata();

	const playerInfo = {
		name: userdata?.name ?? '',
		avatar: userdata?.avatar ?? 'assets/Avatars/vv/AvatarVV_0071.png',
		achievementProgress: userdata?.achievementProgress ?? 0,
		inviteCode: userdata?.id ?? '',
	};

	return (
		<GamerTag player={playerInfo} {...props} />
	);
};

export default React.memo(PlayerTag);
